var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"titlename":"我的学习地图执行情况管理","titlecontent":"这里可以看到学习地图执行情况管理","mbx":_vm.paths}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }